const PL = [
	"kurwa",
	"pierdole",
	"chuj",
	"huj",
	"jebac",
	"pizda",
	"skurwysyn",
	"sukinsyn",
	"dziwka",
	"cwel",
	"dupa",
	"wypierdalaj",
	"jebany",
	"pierdolony",
	"ciota",
	"suka",
	"gówno",
	"szmata",
	"kurwiszon",
	"wkurwiać",
	"kurwica",
	"sperma",
	"zajebisty",
	"zajebiście",
	"kurwidołek",
	"jebnięty",
	"pizdeczka",
	"cipka",
	"dupcia",
	"dupny",
	"suczka",
	"suczysko",
	"dziwkarski",
	"dziwkować",
	"cipunia",
	"cipucha",
	"kutasik",
	"kutasisko",
	"pierdol się",
	"pierdolę cię",
	"pierdolić cię",
	"spierdalaj",
	"kurwa mać",
	"kurwy",
	"kurwie",
	"kurwą",
	"kurwiska",
	"kurwiszcze",
	"jebie",
	"jebana",
	"jebane",
	"jebani",
	"jebanko",
	"wkurwia",
	"wkurwiony",
	"wkurwiona",
	"wkurwione",
	"wkurwiający",
	"wkurwiająca",
	"wkurwiające",
	"chuje",
	"chujnia",
	"chujowy",
	"chujowe",
	"spermy",
	"spermowy",
	"cwelka",
	"dupy",
	"dupina",
	"szmaty",
	"szmaciana",
	"szmaciarz",
	"kurwić",
	"kurwienie",
	"kurwa twoja mać",
	"kurwa jebana",
	"jebana suka",
	"jebany skurwysyn",
	"jebana kurwa",
	"pierdolisz",
	"pierdolenie",
	"pierdolę",
	"pierdolił",
	"pierdolić",
	"pierdolisz",
	"pierdoleniem",
	"pierdolenia",
	"penis",
]

const EN = [
	"fuck",
	"fucking",
	"motherfucker",
	"shit",
	"bitch",
	"asshole",
	"dick",
	"pussy",
	"cock",
	"bastard",
	"slut",
	"cunt",
	"douchebag",
	"bollocks",
	"prick",
	"twat",
	"wanker",
	"bugger",
	"bollocks",
	"arsehole",
	"piss off",
	"son of a bitch",
	"bloody hell",
	"damn",
	"goddamn",
	"motherfucking",
	"cocksucker",
	"dickhead",
	"piss",
	"balls",
	"jerk off",
	"whore",
	"cum",
	"shithead",
	"cockhead",
	"douche",
	"wank",
	"fag",
	"faggot",
	"bitchy",
	"dickwad",
	"dickweed",
	"shitfaced",
	"asshat",
	"asswipe",
	"shitshow",
	"ballsy",
	"shag",
	"arse",
	"goddammit",
	"hell",
	"bullshit",
	"clusterfuck",
	"shitbag",
	"cuntface",
	"douchefag",
	"pisshead",
	"shitfucker",
	"fuckface",
	"fuckhead",
	"fuckhole",
	"fucky",
	"fucked",
	"fucker",
	"fucks",
	"fucking hell",
	"fucking shit",
	"shitass",
	"shite",
	"dickface",
	"cumdump",
	"cocktease",
	"fucknut",
	"shitload",
	"shitpile",
	"motherfucking",
	"cockmaster",
	"cuntlicker",
	"fucktard",
	"assmuncher",
	"cumguzzler",
	"dicksucker",
	"twatface",
	"cockslut",
	"fuckwhore",
	"assfucker",
	"shitlicker",
	"balllicker",
	"cuntwhore",
	"dickmuncher",
	"fucksucker",
	"fuckhole",
	"shitbrain",
]

const DE = [
	"scheiße",
	"fick",
	"ficken",
	"arschloch",
	"hure",
	"miststück",
	"wichser",
	"schlampe",
	"hurensohn",
	"fotze",
	"drecksau",
	"schweinehund",
	"schwein",
	"verdammt",
	"scheißkerl",
	"arsch",
	"arschkriecher",
	"arschgeige",
	"kacke",
	"schwachkopf",
	"idiot",
	"blödmann",
	"dummkopf",
	"verpiss dich",
	"leck mich",
	"scheißdreck",
	"scheißegal",
	"scheißkerl",
	"scheißhaufen",
	"scheißhaus",
	"scheißgesicht",
	"scheißkopf",
	"scheißtyp",
	"scheißweib",
	"scheißfrau",
	"scheißmann",
	"scheißkind",
	"scheißjunge",
	"scheißmädchen",
	"verfickte scheiße",
	"fick dich",
	"fick mich",
	"fick ihn",
	"fick sie",
	"fick euch",
	"fick alles",
	"fick jeden",
	"fick dich ins knie",
	"fick dein leben",
	"fick deine mutter",
	"fick deinen vater",
	"fick deine schwester",
	"fick deinen bruder",
	"fick deine oma",
	"fick deinen opa",
	"fick dein kind",
	"fick dein haus",
	"fick dein auto",
	"fick dein leben",
	"fick deine seele",
	"hurenbock",
	"hurensöhne",
	"hurentochter",
	"scheißarsch",
	"scheißgesicht",
	"scheißfresse",
	"scheißhure",
	"arschficker",
	"arschlecker",
	"arschlochkind",
	"arschlochmann",
	"arschlochfrau",
	"drecksack",
	"dreckskerl",
	"dreckschwein",
	"wichskopf",
	"wichsgesicht",
	"wichserkind",
	"wichsermann",
	"wichserfrau",
	"mistkerl",
	"mistvieh",
	"miststück",
	"scheißbock",
	"scheißvieh",
	"scheißhund",
	"scheißkatze",
	"scheißfisch",
	"scheißkuh",
	"scheißziege",
	"scheißmaus",
]

export default [...PL, ...EN, ...DE]
